import React from 'react'
import Base from './Base'
import Warning from '../../Images/warning.gif'
import StepsUserFormBase from './StepsUserFormBase'
import { API, Auth } from "aws-amplify"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"
import { Form, Card , Button, Row, Col, message, Spin } from "antd"
import { withBreakpoints } from "react-breakpoints"
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {CustomSpinner} from "../../Components/Spin/CustomSpiner"
import { ConsoleView } from 'react-device-detect'
import Success from '../../Images/success.gif'
import Error from '../../Images/error.gif'

class PostCheckoutPending extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            loading : true,
            firstMsg : "",
            secondMsg : "",
            sourceImg : null,
            error: false,
            success: false,
            pending: false
        }
    }

    handleErrorMessage(err){
        let errorMessage = ""
        switch (err) {
            case 'cc_rejected_bad_filled_card_number':
                errorMessage = 'Hay un error en los datos ingresados, por favor asegurate de estar colocandolos bien.'
                break;
            case 'cc_rejected_bad_filled_date':
                errorMessage = 'Hay un error en los datos ingresados, por favor asegurate de estar colocandolos bien.'
                break;
            case 'cc_rejected_bad_filled_other':
                errorMessage = 'Hay un error en los datos ingresados, por favor asegurate de estar colocandolos bien.'
                break;
            case 'cc_rejected_bad_filled_security_code':
                errorMessage = 'Hay un error en los datos ingresados, por favor asegurate de estar colocandolos bien.'
                break;
            case 'cc_rejected_blacklist':
                errorMessage = 'Tu cobro ha sido rechazado por Mercado Pago. Intentá con otra tarjeta.'
                break;
            case 'cc_rejected_call_for_authorize':
                errorMessage = 'Tu cobro ha sido rechazado por Mercado Pago. Intentá con otra tarjeta.'
                break;
            case 'cc_rejected_high_risk':
                errorMessage = 'Tu cobro ha sido rechazado por Mercado Pago. Intentá con otra tarjeta.'
                break;
            case 'cc_rejected_insufficient_amount':
                errorMessage = 'Tu tarjeta no tiene fondos suficientes. Por favor intentá con otra tarjeta.'
                break;
            case 'cc_rejected_other_reason':
                errorMessage = 'Tu cobro ha sido rechazado por Mercado Pago. Intentá con otra tarjeta.'
                break;
            default:
                errorMessage = 'Tu pago fue rechazado. Por favor intentá con otro medio de pago.'
                break;
        }
        return errorMessage
    }

    handlePostPending(resp){

        if (resp.status === "SUCCEEDED"){
            let first = "Te informamos que tu pago ha sido realizado con éxito"
            let second = "Recibirás un email cuando procesemos tu pago. En breve te redireccionaremos para continuar con tu proceso"
            this.setState({ firstMsg: first, secondMsg: second, sourceImg: Success, success: true, loading:false})
        }
        else if (resp.status === "FAILED"){
            let first = this.handleErrorMessage(resp.errorMessage)
            let second = "Vas a ser redireccionado para comenzar nuevamente"
            this.setState({ firstMsg: first, secondMsg: second, sourceImg: Error, error: true, loading:false})
        }
        else{
            let first = "Tu pago se encuentra pendiente, recibiras un email cuando tengamos información de tu pago"
            let second = "Ante cualquier inconveniente, no dudes en consultarnos 😀😀"
            this.setState({ firstMsg: first, secondMsg: second, sourceImg: Warning, pending:true, loading:false})
        }
    }

    componentDidMount(){
        Auth.currentSession()
        .then(response => {
            API.get(
                'test',
                '/root/users/me/handleCheckout',
                {
                    headers: {
                        Authorization: response.getIdToken().getJwtToken()
                    },
                    queryStringParameters:{
                        payment_id: this.props.history.location.state.payment
                    }
                }
            )
                .then(response => {
                    this.handlePostPending(response)
                })
                .catch(err =>{
                    let first = "Tu pago fue rechazado. Por favor intentá con otro medio de pago."
                    let second = "Vas a ser redireccionado para comenzar nuevamente"
                    this.setState({ firstMsg: first, secondMsg: second, sourceImg: Error, error: true, loading:false})
                })
            })
        .catch(err => {
            message.error('Sesion vencida, vuelve a loguearte por favor')
            this.props.history.push('/')
        })
    }

    render() {

        if (this.props.history.location.state.isStepUser){
            if(this.state.loading === true){
                return (
                    <StepsUserFormBase>
                        <Row></Row>
                        <Row type="flex" justify="space-around" align="middle" style={{marginTop:'150px'}}>
                            <Col style={{minHeight:'360px'}}>
                                <Spin indicator={CustomSpinner}/>
                            </Col>
                        </Row>
                        <Row></Row>
                    </StepsUserFormBase>)}
            else{
                return(
                    <StepsUserFormBase>
                        <center>
                            <h1> {this.state.firstMsg} </h1>
                            <h1> {this.state.secondMsg}</h1>
                            <img alt="generic-checkout" src={this.state.sourceImg} className="checkout" style={{ height: "300px", marginTop: "15px", marginBottom: "15px" }} />
                        </center>
                        <center>
                            <Col>
                                <Row>
                                    {
                                        this.state.success && <Button 
                                            style={{
                                            color: '#FFFFFF' ,
                                            background: '#353FDF',
                                            border: '1px solid #353FDF',
                                            borderRadius: '5px',
                                            marginLeft: '5px',
                                            marginRight: '5px'
                                            }}
                                            onClick={() => this.props.history.push("/")}> Continuar
                                        </Button>
                                    }
                                    
                                    {
                                        this.state.error && <Button 
                                            style={{
                                            color: '#FFFFFF' ,
                                            background: '#353FDF',
                                            border: '1px solid #353FDF',
                                            borderRadius: '5px',
                                            marginLeft: '5px',
                                            marginRight: '5px' 
                                            }}
                                            onClick={() => this.props.history.push("/")}> Continuar sin pagar
                                        </Button>
                                    }
                                    
                                    {
                                        this.state.error && <Button
                                            style={{
                                                marginLeft: '5px',
                                                marginRight: '5px'
                                            }}
                                            onClick={() => this.props.history.push("/initial-plan/0")}> Reintentar
                                        </Button>
                                    }
                                </Row>
                            </Col>
                        </center>
                    </StepsUserFormBase>
                )
            }
        }else{
            if(this.state.loading === true){
                return (
                    <Base>
                        <Row></Row>
                        <Row type="flex" justify="space-around" align="middle" style={{marginTop:'150px'}}>
                            <Col style={{minHeight:'360px'}}>
                                <Spin indicator={CustomSpinner}/>
                            </Col>
                        </Row>
                        <Row></Row>
                    </Base>)}
            else{
                return (
                    <Base
                        selected = "checkout-error">
                        <Card>
                            <center>
                                <h1> {this.state.firstMsg} </h1>
                                <h1> {this.state.secondMsg}</h1>
                                <img alt="generic-checkout" src={this.state.sourceImg} className="checkout" style={{ height: "300px", marginTop: "15px", marginBottom: "15px" }} />
                            </center>
                            <center>   
                            {
                                (this.state.success || this.state.pending) &&
                                    <Button 
                                        style={{
                                            color: '#FFFFFF' ,
                                            background: '#353FDF',
                                            border: '1px solid #353FDF',
                                            borderRadius: '5px' 
                                        }}
                                        onClick={() => this.props.history.push("/")}> Volver al inicio 
                                    </Button>
                            }
                            {
                                this.state.error && 
                                    <Button 
                                        style={{
                                            color: '#FFFFFF' ,
                                            background: '#353FDF',
                                            border: '1px solid #353FDF',
                                            borderRadius: '5px' 
                                        }}
                                        onClick={() => this.props.history.push("/mejorar-plan")}> Reintentar 
                                    </Button>
                            }
                            </center>
                        </Card>
                    </Base>
                )
            }
        }
    }
}

const Checkout = Form.create({ nombre: 'checkout-pending' })(withBreakpoints(PostCheckoutPending));
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Checkout));